export const TimezoneList: { name: string; caption: string; offset: number; disabled?: boolean }[] =
    [
        {
            name: 'International Date Line West',
            caption: '(GMT-12:00) International Date Line West',
            offset: -43200,
        },
        { name: 'American Samoa', caption: '(GMT-11:00) American Samoa', offset: -39600 },
        { name: 'Midway Island', caption: '(GMT-11:00) Midway Island', offset: -39600 },
        { name: 'Hawaii', caption: '(GMT-10:00) Hawaii', offset: -36000 },
        { name: 'Alaska', caption: '(GMT-09:00) Alaska', offset: -32400 },
        {
            name: 'Pacific Time (US \u0026 Canada)',
            caption: '(GMT-08:00) Pacific Time (US \u0026 Canada)',
            offset: -28800,
        },
        { name: 'Tijuana', caption: '(GMT-08:00) Tijuana', offset: -28800 },
        { name: 'Arizona', caption: '(GMT-07:00) Arizona', offset: -25200 },
        { name: 'Chihuahua', caption: '(GMT-07:00) Chihuahua', offset: -25200 },
        { name: 'Mazatlan', caption: '(GMT-07:00) Mazatlan', offset: -25200 },
        {
            name: 'Mountain Time (US \u0026 Canada)',
            caption: '(GMT-07:00) Mountain Time (US \u0026 Canada)',
            offset: -25200,
        },
        { name: 'Central America', caption: '(GMT-06:00) Central America', offset: -21600 },
        {
            name: 'Central Time (US \u0026 Canada)',
            caption: '(GMT-06:00) Central Time (US \u0026 Canada)',
            offset: -21600,
        },
        { name: 'Guadalajara', caption: '(GMT-06:00) Guadalajara', offset: -21600 },
        { name: 'Mexico City', caption: '(GMT-06:00) Mexico City', offset: -21600 },
        { name: 'Monterrey', caption: '(GMT-06:00) Monterrey', offset: -21600 },
        { name: 'Saskatchewan', caption: '(GMT-06:00) Saskatchewan', offset: -21600 },
        { name: 'Bogota', caption: '(GMT-05:00) Bogota', offset: -18000 },
        {
            name: 'Eastern Time (US \u0026 Canada)',
            caption: '(GMT-05:00) Eastern Time (US \u0026 Canada)',
            offset: -18000,
        },
        { name: 'Indiana (East)', caption: '(GMT-05:00) Indiana (East)', offset: -18000 },
        { name: 'Lima', caption: '(GMT-05:00) Lima', offset: -18000 },
        { name: 'Quito', caption: '(GMT-05:00) Quito', offset: -18000 },
        {
            name: 'Atlantic Time (Canada)',
            caption: '(GMT-04:00) Atlantic Time (Canada)',
            offset: -14400,
        },
        { name: 'Caracas', caption: '(GMT-04:00) Caracas', offset: -14400 },
        { name: 'Georgetown', caption: '(GMT-04:00) Georgetown', offset: -14400 },
        { name: 'La Paz', caption: '(GMT-04:00) La Paz', offset: -14400 },
        { name: 'Puerto Rico', caption: '(GMT-04:00) Puerto Rico', offset: -14400 },
        { name: 'Santiago', caption: '(GMT-04:00) Santiago', offset: -14400 },
        { name: 'Newfoundland', caption: '(GMT-03:30) Newfoundland', offset: -12600 },
        { name: 'Brasilia', caption: '(GMT-03:00) Brasilia', offset: -10800 },
        { name: 'Buenos Aires', caption: '(GMT-03:00) Buenos Aires', offset: -10800 },
        { name: 'Greenland', caption: '(GMT-03:00) Greenland', offset: -10800 },
        { name: 'Montevideo', caption: '(GMT-03:00) Montevideo', offset: -10800 },
        { name: 'Mid-Atlantic', caption: '(GMT-02:00) Mid-Atlantic', offset: -7200 },
        { name: 'Azores', caption: '(GMT-01:00) Azores', offset: -3600 },
        { name: 'Cape Verde Is.', caption: '(GMT-01:00) Cape Verde Is.', offset: -3600 },
        { name: 'Casablanca', caption: '(GMT+00:00) Casablanca', offset: 0 },
        { name: 'Dublin', caption: '(GMT+00:00) Dublin', offset: 0 },
        { name: 'Edinburgh', caption: '(GMT+00:00) Edinburgh', offset: 0 },
        { name: 'Lisbon', caption: '(GMT+00:00) Lisbon', offset: 0 },
        { name: 'London', caption: '(GMT+00:00) London', offset: 0 },
        { name: 'Monrovia', caption: '(GMT+00:00) Monrovia', offset: 0 },
        { name: 'UTC', caption: '(GMT+00:00) UTC', offset: 0 },
        { name: 'Amsterdam', caption: '(GMT+01:00) Amsterdam', offset: 3600 },
        { name: 'Belgrade', caption: '(GMT+01:00) Belgrade', offset: 3600 },
        { name: 'Berlin', caption: '(GMT+01:00) Berlin', offset: 3600 },
        { name: 'Bern', caption: '(GMT+01:00) Bern', offset: 3600 },
        { name: 'Bratislava', caption: '(GMT+01:00) Bratislava', offset: 3600 },
        { name: 'Brussels', caption: '(GMT+01:00) Brussels', offset: 3600 },
        { name: 'Budapest', caption: '(GMT+01:00) Budapest', offset: 3600 },
        { name: 'Copenhagen', caption: '(GMT+01:00) Copenhagen', offset: 3600 },
        { name: 'Ljubljana', caption: '(GMT+01:00) Ljubljana', offset: 3600 },
        { name: 'Madrid', caption: '(GMT+01:00) Madrid', offset: 3600 },
        { name: 'Paris', caption: '(GMT+01:00) Paris', offset: 3600 },
        { name: 'Prague', caption: '(GMT+01:00) Prague', offset: 3600 },
        { name: 'Rome', caption: '(GMT+01:00) Rome', offset: 3600 },
        { name: 'Sarajevo', caption: '(GMT+01:00) Sarajevo', offset: 3600 },
        { name: 'Skopje', caption: '(GMT+01:00) Skopje', offset: 3600 },
        { name: 'Stockholm', caption: '(GMT+01:00) Stockholm', offset: 3600 },
        { name: 'Vienna', caption: '(GMT+01:00) Vienna', offset: 3600 },
        { name: 'Warsaw', caption: '(GMT+01:00) Warsaw', offset: 3600 },
        { name: 'West Central Africa', caption: '(GMT+01:00) West Central Africa', offset: 3600 },
        { name: 'Zagreb', caption: '(GMT+01:00) Zagreb', offset: 3600 },
        { name: 'Zurich', caption: '(GMT+01:00) Zurich', offset: 3600 },
        { name: 'Athens', caption: '(GMT+02:00) Athens', offset: 7200 },
        { name: 'Bucharest', caption: '(GMT+02:00) Bucharest', offset: 7200 },
        { name: 'Cairo', caption: '(GMT+02:00) Cairo', offset: 7200 },
        { name: 'Harare', caption: '(GMT+02:00) Harare', offset: 7200 },
        { name: 'Helsinki', caption: '(GMT+02:00) Helsinki', offset: 7200 },
        { name: 'Jerusalem', caption: '(GMT+02:00) Jerusalem', offset: 7200 },
        { name: 'Kaliningrad', caption: '(GMT+02:00) Kaliningrad', offset: 7200 },
        { name: 'Kyiv', caption: '(GMT+02:00) Kyiv', offset: 7200 },
        { name: 'Pretoria', caption: '(GMT+02:00) Pretoria', offset: 7200 },
        { name: 'Riga', caption: '(GMT+02:00) Riga', offset: 7200 },
        { name: 'Sofia', caption: '(GMT+02:00) Sofia', offset: 7200 },
        { name: 'Tallinn', caption: '(GMT+02:00) Tallinn', offset: 7200 },
        { name: 'Vilnius', caption: '(GMT+02:00) Vilnius', offset: 7200 },
        { name: 'Baghdad', caption: '(GMT+03:00) Baghdad', offset: 10800 },
        { name: 'Istanbul', caption: '(GMT+03:00) Istanbul', offset: 10800 },
        { name: 'Kuwait', caption: '(GMT+03:00) Kuwait', offset: 10800 },
        { name: 'Minsk', caption: '(GMT+03:00) Minsk', offset: 10800 },
        { name: 'Moscow', caption: '(GMT+03:00) Moscow', offset: 10800 },
        { name: 'Nairobi', caption: '(GMT+03:00) Nairobi', offset: 10800 },
        { name: 'Riyadh', caption: '(GMT+03:00) Riyadh', offset: 10800 },
        { name: 'St. Petersburg', caption: '(GMT+03:00) St. Petersburg', offset: 10800 },
        { name: 'Volgograd', caption: '(GMT+03:00) Volgograd', offset: 10800 },
        { name: 'Tehran', caption: '(GMT+03:30) Tehran', offset: 12600 },
        { name: 'Abu Dhabi', caption: '(GMT+04:00) Abu Dhabi', offset: 14400 },
        { name: 'Baku', caption: '(GMT+04:00) Baku', offset: 14400 },
        { name: 'Muscat', caption: '(GMT+04:00) Muscat', offset: 14400 },
        { name: 'Samara', caption: '(GMT+04:00) Samara', offset: 14400 },
        { name: 'Tbilisi', caption: '(GMT+04:00) Tbilisi', offset: 14400 },
        { name: 'Yerevan', caption: '(GMT+04:00) Yerevan', offset: 14400 },
        { name: 'Kabul', caption: '(GMT+04:30) Kabul', offset: 16200 },
        { name: 'Ekaterinburg', caption: '(GMT+05:00) Ekaterinburg', offset: 18000 },
        { name: 'Islamabad', caption: '(GMT+05:00) Islamabad', offset: 18000 },
        { name: 'Karachi', caption: '(GMT+05:00) Karachi', offset: 18000 },
        { name: 'Tashkent', caption: '(GMT+05:00) Tashkent', offset: 18000 },
        { name: 'Chennai', caption: '(GMT+05:30) Chennai', offset: 19800 },
        { name: 'Kolkata', caption: '(GMT+05:30) Kolkata', offset: 19800 },
        { name: 'Mumbai', caption: '(GMT+05:30) Mumbai', offset: 19800 },
        { name: 'New Delhi', caption: '(GMT+05:30) New Delhi', offset: 19800 },
        { name: 'Sri Jayawardenepura', caption: '(GMT+05:30) Sri Jayawardenepura', offset: 19800 },
        { name: 'Kathmandu', caption: '(GMT+05:45) Kathmandu', offset: 20700 },
        { name: 'Almaty', caption: '(GMT+06:00) Almaty', offset: 21600 },
        { name: 'Astana', caption: '(GMT+06:00) Astana', offset: 21600 },
        { name: 'Dhaka', caption: '(GMT+06:00) Dhaka', offset: 21600 },
        { name: 'Urumqi', caption: '(GMT+06:00) Urumqi', offset: 21600 },
        { name: 'Rangoon', caption: '(GMT+06:30) Rangoon', offset: 23400 },
        { name: 'Bangkok', caption: '(GMT+07:00) Bangkok', offset: 25200 },
        { name: 'Hanoi', caption: '(GMT+07:00) Hanoi', offset: 25200 },
        { name: 'Jakarta', caption: '(GMT+07:00) Jakarta', offset: 25200 },
        { name: 'Krasnoyarsk', caption: '(GMT+07:00) Krasnoyarsk', offset: 25200 },
        { name: 'Novosibirsk', caption: '(GMT+07:00) Novosibirsk', offset: 25200 },
        { name: 'Beijing', caption: '(GMT+08:00) Beijing', offset: 28800 },
        { name: 'Chongqing', caption: '(GMT+08:00) Chongqing', offset: 28800 },
        { name: 'Hong Kong', caption: '(GMT+08:00) Hong Kong', offset: 28800 },
        { name: 'Irkutsk', caption: '(GMT+08:00) Irkutsk', offset: 28800 },
        { name: 'Kuala Lumpur', caption: '(GMT+08:00) Kuala Lumpur', offset: 28800 },
        { name: 'Perth', caption: '(GMT+08:00) Perth', offset: 28800 },
        { name: 'Singapore', caption: '(GMT+08:00) Singapore', offset: 28800 },
        { name: 'Taipei', caption: '(GMT+08:00) Taipei', offset: 28800 },
        { name: 'Ulaanbaatar', caption: '(GMT+08:00) Ulaanbaatar', offset: 28800 },
        { name: 'Osaka', caption: '(GMT+09:00) Osaka', offset: 32400 },
        { name: 'Sapporo', caption: '(GMT+09:00) Sapporo', offset: 32400 },
        { name: 'Seoul', caption: '(GMT+09:00) Seoul', offset: 32400 },
        { name: 'Tokyo', caption: '(GMT+09:00) Tokyo', offset: 32400 },
        { name: 'Yakutsk', caption: '(GMT+09:00) Yakutsk', offset: 32400 },
        { name: 'Adelaide', caption: '(GMT+09:30) Adelaide', offset: 34200 },
        { name: 'Darwin', caption: '(GMT+09:30) Darwin', offset: 34200 },
        { name: 'Brisbane', caption: '(GMT+10:00) Brisbane', offset: 36000 },
        { name: 'Canberra', caption: '(GMT+10:00) Canberra', offset: 36000 },
        { name: 'Guam', caption: '(GMT+10:00) Guam', offset: 36000 },
        { name: 'Hobart', caption: '(GMT+10:00) Hobart', offset: 36000 },
        { name: 'Melbourne', caption: '(GMT+10:00) Melbourne', offset: 36000 },
        { name: 'Port Moresby', caption: '(GMT+10:00) Port Moresby', offset: 36000 },
        { name: 'Sydney', caption: '(GMT+10:00) Sydney', offset: 36000 },
        { name: 'Vladivostok', caption: '(GMT+10:00) Vladivostok', offset: 36000 },
        { name: 'Magadan', caption: '(GMT+11:00) Magadan', offset: 39600 },
        { name: 'New Caledonia', caption: '(GMT+11:00) New Caledonia', offset: 39600 },
        { name: 'Solomon Is.', caption: '(GMT+11:00) Solomon Is.', offset: 39600 },
        { name: 'Srednekolymsk', caption: '(GMT+11:00) Srednekolymsk', offset: 39600 },
        { name: 'Auckland', caption: '(GMT+12:00) Auckland', offset: 43200 },
        { name: 'Fiji', caption: '(GMT+12:00) Fiji', offset: 43200 },
        { name: 'Kamchatka', caption: '(GMT+12:00) Kamchatka', offset: 43200 },
        { name: 'Marshall Is.', caption: '(GMT+12:00) Marshall Is.', offset: 43200 },
        { name: 'Wellington', caption: '(GMT+12:00) Wellington', offset: 43200 },
        { name: 'Chatham Is.', caption: '(GMT+12:45) Chatham Is.', offset: 45900 },
        { name: "Nuku'alofa", caption: "(GMT+13:00) Nuku'alofa", offset: 46800 },
        { name: 'Samoa', caption: '(GMT+13:00) Samoa', offset: 46800 },
        { name: 'Tokelau Is.', caption: '(GMT+13:00) Tokelau Is.', offset: 46800 },
        {
            name: '------------ Other Timezones ------------',
            caption: '------------ Other Timezones ------------',
            offset: 0,
            disabled: true,
        },
    ];

TimezoneList.sort((a, b) => {
    if (a.caption.includes('US') && b.caption.includes('US')) {
        return 0;
    } else if (a.caption.includes('US')) {
        return -1;
    } else if (b.caption.includes('US')) {
        return 1;
    }
    return a.caption.toLocaleLowerCase().localeCompare(b.caption.toLocaleLowerCase());
});
